<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
    <template v-if="$route.path != '/'">
      <!-- 系统头部通知消息提醒 -->
      <TopMsg v-if="message" :msg="message"></TopMsg>
      <!-- 过期提醒 -->
      <ErrHint v-if="error401?.code" :error401="error401"></ErrHint>
    </template>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
export default {
  provide() {
    return {
      reload: this.reload
    }
  },
  components: {},
  data() {
    return {
      message: '',
      isRouterAlive: true
    };
  },
  computed: { ...mapState(['toDoMsg', 'error401']) },
  watch: {
    toDoMsg: {
      immediate: true,
      deep: true,
      handler(msg) {
        this.message = '';
        setTimeout(() => {
          if (msg) this.message = msg;
        }, 200);
      },
    },
  },
  created() { },
  mounted() { },

  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  },
};
</script>
<style>
#app {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
}
</style>
